// extracted by mini-css-extract-plugin
export var btn = "L_mY q_rK q_rp d_bz d_bP d_bD d_dw";
export var full = "L_wH d_w d_H";
export var hoverStyle = "L_m1";
export var zoom = "L_m2";